<!--  -->
<template>
  <div>
    <div class="cont_r_b11">
      <p>
        <img :src="images.jsmd">
      </p>
      <p>
        <b>
          <span style="font-size:18px;font-family:宋体;">Mn Lumpy</span>
        </b>
      </p>
      <p>
        <span style="font-size:12px;font-family:Arial;">Mn</span>
        <span style="font-size:12px;font-family:Arial;">
          95%min, C 0.2%max, Si 1.8%max,
          P 0.07%max
        </span>
      </p>
      <p>
        <br>
      </p>
      <p>
        <img :src="images.jsmp">
      </p>
      <p>
        <br>
      </p>
      <p>
        <b>
          <span style="font-size:18px;font-family:宋体;">Mn Flake</span>
        </b>
      </p>
      <p>
        <span style="font-family:Arial;font-size:12px;line-height:1.5;">
          Mn
          99.7%min, S 0.05%max, P 0.005%max, C 0.04%max, Fe+Se+Si 0.205%max
        </span>
      </p>
      <p>
        <br>
      </p>
      <p>
        <br>
      </p>
      <p>
        <img :src="images.jsmz">
      </p>
      <p>
        <br>
      </p>
      <p>
        <b>
          <span style="font-size:18px;font-family:宋体;">Mn Briquettes</span>
        </b>
      </p>
      <p>
        <span style="font-size:12px;font-family:Arial;">
          Mn97%min,&nbsp;C&nbsp;0.04%max,&nbsp;S&nbsp;0.05%max,&nbsp;P
          0.01%max,&nbsp;Si&nbsp;1.0%max,&nbsp;Se 0.08%max.
        </span>
        <b>
          <u>
            <span style="font-size:16.0pt;font-family:Arial;"></span>
          </u>
        </b>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">&nbsp;</span>
      </p>
      <p>
        <span style="font-size:12px;font-family:宋体;">Technical requirements for Mn metal briquettes</span>
        <span style="font-size:12.0pt;font-family:Arial;"></span>
      </p>
      <p style="margin-left:18.0pt;text-align:left;text-indent:-18.0pt;" align="left">
        <span style="font-size:12.0pt;font-family:Arial;">
          <span>
            <span style="font-size:12px;">1.</span>
            <span style="font-size:12px;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
        </span>
        <span style="font-size:12px;font-family:宋体;">Specification</span>
        <span style="font-size:12.0pt;font-family:Arial;"></span>
      </p>
      <p style="margin-left:0cm;text-align:left;text-indent:0cm;" align="left">
        <span style="font-size:12px;font-family:Arial;">
          <span style="font-size:12px;">
            <span
              style="font-size:12px;"
            >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
        </span>
        <span style="font-size:12px;font-family:宋体;">Dimension：length</span>
        <span style="font-size:12px;font-family:Arial;">55mm</span>
        <span style="font-size:12px;font-family:宋体;">，width</span>
        <span style="font-size:12px;font-family:Arial;">35mm</span>
        <span style="font-size:12px;font-family:宋体;">，height</span>
        <span style="font-size:12px;font-family:Arial;">25mm</span>
        <span style="font-size:12px;font-family:宋体;">，weight</span>
        <span style="font-size:12.0pt;font-family:Arial;">
          <span style="font-size:12px;">200-250</span>
          <span style="font-family:宋体;font-size:12px;">
            <span style="font-size:12px;">grams each piece</span>
          </span>
          <span style="font-family:宋体;font-size:12px;">.</span>
        </span>
      </p>
      <p style="margin-left:0cm;text-align:left;text-indent:0cm;" align="left">
        <span style="font-size:12px;font-family:Arial;">
          <span style="font-size:12px;">
            <span
              style="font-size:12px;"
            >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
        </span>
        <span style="font-size:12px;font-family:宋体;">Briquette-shaped</span>
        <span style="font-size:12.0pt;font-family:Arial;"></span>
      </p>
      <p style="margin-left:18.0pt;text-align:left;text-indent:-18.0pt;" align="left">
        <span style="font-size:12.0pt;font-family:Arial;">
          <span>
            <span style="font-size:12px;">2.</span>
            <span style="font-size:12px;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
        </span>
        <span style="font-size:12px;font-family:宋体;">Technical requirements</span>
        <span style="font-size:12.0pt;font-family:Arial;"></span>
      </p>
      <table
        style="border-collapse:collapse;border:none;"
        border="1"
        cellpadding="0"
        cellspacing="0"
      >
        <tbody>
          <tr>
            <td rowspan="3" style="border:solid windowtext 1.0pt;" width="109">
              <p style="text-align:center;" align="center">
                <span style="font-size:12px;font-family:宋体;">Grade</span>
                <span style="font-size:12.0pt;font-family:Arial;"></span>
              </p>
            </td>
            <td colspan="4" style="border:solid windowtext 1.0pt;" valign="top" width="438">
              <p style="text-align:center;" align="center">
                <span style="font-size:12px;font-family:宋体;">Chemical composition，mass pct</span>
                <span style="font-size:12px;font-family:Arial;">%</span>
              </p>
            </td>
            <td rowspan="3" style="border:solid windowtext 1.0pt;" width="110">
              <p style="text-align:center;" align="center">
                <span style="font-size:12px;font-family:宋体;">Moisture</span>
                <span style="font-size:12px;font-family:Arial;">,%</span>
              </p>
            </td>
          </tr>
          <tr>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="109">
              <p>
                <span style="font-size:12px;font-family:Arial;">Mn</span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="109">
              <p>
                <span style="font-size:12px;font-family:Arial;">Si</span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="110">
              <p>
                <span style="font-size:12px;font-family:Arial;">S</span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="110">
              <p>
                <span style="font-size:12px;font-family:Arial;">P</span>
              </p>
            </td>
          </tr>
          <tr>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="109">
              <p>
                <span style="font-size:12px;font-family:Arial;">min</span>
              </p>
            </td>
            <td colspan="3" style="border:solid windowtext 1.0pt;" valign="top" width="329">
              <p style="text-align:center;" align="center">
                <span style="font-size:12px;font-family:Arial;">max</span>
              </p>
            </td>
          </tr>
          <tr>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="109">
              <p>
                <span style="font-size:12px;font-family:Arial;">Mn97</span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="109">
              <p>
                <span style="font-size:12px;font-family:Arial;">97.0</span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="109">
              <p>
                <span style="font-size:12px;font-family:Arial;">0.5</span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="110">
              <p>
                <span style="font-size:12px;font-family:Arial;">0.005</span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="110">
              <p>
                <span style="font-size:12px;font-family:Arial;">0.007</span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="110">
              <p>
                <span style="font-size:12px;font-family:Arial;">0.5</span>
              </p>
            </td>
          </tr>
        </tbody>
      </table>
      <p>
        <span style="font-size:12px;font-family:Arial;">3.</span>
        <span style="font-size:12px;font-family:宋体;">Briquette strength</span>
        <span style="font-size:12.0pt;font-family:Arial;"></span>
      </p>
      <p>
        <span style="font-size:12px;font-family:宋体;">Minimum</span>
        <span style="font-size:12px;font-family:Arial;">180kg</span>
        <span style="font-size:12px;font-family:宋体;">before briquette breakage/destruction</span>
        <span style="font-size:12.0pt;font-family:Arial;"></span>
      </p>
      <br>
      <span style="font-size:12.0pt;font-family:Arial;"></span>
      <p>
        <br>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      images: {
        jsmd: require("../../../assets/img/common/jsmd.jpg"),
        jsmp: require("../../../assets/img/common/jsmp.jpg"),
        jsmz: require("../../../assets/img/common/jsmz.jpg")
      }
    };
  },

  components: {},

  methods: {}
};
</script>
<style lang='stylus' rel='stylesheet/stylus'>
</style>


// WEBPACK FOOTER //
// src/components/ew/product/gtll.vue